import { ColumnConfig } from './lookup-screen.types';

export interface DomainTableData<T> {
  domainId: string;
  items: T[];
  filteredItems: T[];
  selectedItems?: T[];
  searchTerm: string;
  selectedFilterFields: string[];
  columnVisibility: Record<string, boolean>;
}

export interface DomainTableConfig {
  columns: ColumnConfig[];
  defaultPageSize: number;
  pageSizeOptions: number[];
}

export function createDomainTableData<T>(
  domainId: string,
  items: T[],
  columnVisibility: Record<string, boolean>,
): DomainTableData<T> {
  return {
    domainId,
    items,
    filteredItems: items,
    selectedItems: [],
    searchTerm: '',
    selectedFilterFields: ['all'],
    columnVisibility: { ...columnVisibility },
  };
}

export function initializeColumnVisibility(
  columns: ColumnConfig[],
): Record<string, boolean> {
  const visibility: Record<string, boolean> = {};
  columns.forEach((column) => {
    visibility[column.key] = column.visible;
  });
  return visibility;
}
